import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { DEFAULT_FILTER_NOTIFICATIONS_QUERY_PARAMS } from "../api";
import NotificationPageFilterForm from "../components/views/NotificationPageFilterForm";
import NotificationTable from "../components/views/NotificationTable";
import { NotificationFilterPageRequest } from "../types";

export const NotificationPageContainer = () => {
  const searchParams = useFilterSearchParams<NotificationFilterPageRequest>({
    params: ["onlyUnseen", "topics", "sentAtMin", "sentAtMax"],
    defaultQueryParamsObject: DEFAULT_FILTER_NOTIFICATIONS_QUERY_PARAMS,
  });

  return (
    <>
      <ContentWrapper>
        <NotificationPageFilterForm searchParams={searchParams} />

        <NotificationTable searchParams={searchParams} />
      </ContentWrapper>
    </>
  );
};
